import { Component, Input, OnInit } from '@angular/core';
import { StoreLoader } from '@core-lib/classes/store-loader.class';
import { DateFormatType } from '@core-lib/enums/date-format-type.enum';
import { camelCaseToPascalCase } from '@core-lib/functions/utils.function';
import { CommentService } from '@core-lib/services/comment.service';
import { Subject, of } from 'rxjs';

@Component({
    selector: 'commentaires-history',
    templateUrl: './commentaires-history.component.html',
    styles: [],
    standalone: false
})
export class CommentairesHistoryComponent implements OnInit {
	private _operationId: string;
	@Input() set operationId(value: string) {
		if (value) {
			this._operationId = value;
			this.loadComments();
		}
	}
	get operationId(): string {
		return this._operationId;
	}

	@Input() affaireId: string;
	commentaires: any[];
	loader: StoreLoader = new StoreLoader(of(false), of(null));
	loaderSubject = new Subject<StoreLoader>();
	loader$ = this.loaderSubject.asObservable();
	dateFormatType = DateFormatType;

	constructor(private commentService: CommentService) {}

	ngOnInit(): void {
		this.loader$.subscribe(res => (this.loader = res));
	}

	loadComments(): void {
		this.setLoader(true);
		this.commentService
			.getAvocatCommentsByOperationId(this.affaireId, this.operationId)
			.pipe()
			.subscribe({
				next: response => {
					this.commentaires = response;
					this.setLoader(false);
				},
				error: error => {
					this.setLoader(false, error);
				}
			});
	}

	public firstLetterCapitalize(value: string): string {
		return camelCaseToPascalCase(value);
	}

	setLoader(isLoading: boolean, error = null): void {
		this.loaderSubject.next(new StoreLoader(of(isLoading), of(error)));
	}
}
